import React, { useState } from "react";
import { useQuery } from "@apollo/client";
import { useRouteMatch } from "react-router-dom";
import { Button } from "antd";

import { GET_EVENTS } from 'graphql/query/event-gql';

import GraphicStand from 'components/graphic-stand';
import GraphicStorage from 'components/graphic-storage';
import Icons from "components/icons";
import Events from 'components/events';
import { useActiveMenuItem, useBreadCrumbs } from "components/use-hooks";
import { PageWrapDefault, Tables, TotalItems } from "components/layout";
import { Localize } from "components/service";
import { gqlBuilderWhere } from "utils";


const basePath = GraphicStorage.Const.basePath;
const tableHelper = GraphicStorage.Helpers.TableMain;


const GraphicStoragePage = () => {

    useActiveMenuItem([ "graphic-storage-main" ], [ "graphic-storage" ]);

    const breadcrumbs = [
        {
            label: Localize({ children: "BREADCRUMBS.Label_Exhibitions" }).props.children,
            path: `${ basePath }`
        }
    ]

    useBreadCrumbs(breadcrumbs);

    let match = useRouteMatch(`${ basePath }/page/:pageNum`);

    const [ searchText, setSearchText ] = useState("");
    const [ filters, setFilters ] = useState();
    const [ tableVariables, setTableVariables ] = useState(null);
    const {
        _setGraphicStoredAllExportExcel,
        loadingMutationGraphicStoredAllExportExcel,
        _setGraphicStoredAvailableExportExcel,
        loadingMutationGraphicStoredAvailableExportExcel
    } = GraphicStand.Hooks.exportExcel();
    const { data: eventsData } = useQuery(GET_EVENTS, {
        variables: tableVariables || undefined,
        skip: !tableVariables,
        fetchPolicy: 'cache-first'
    });

    const filterTableName = 'graphicStorageFilters';
    const graphicStorageFilters = JSON.parse(localStorage.getItem(filterTableName));
    const handleExportExcelGraphicStoredAll = () => _setGraphicStoredAllExportExcel();
    const handleExportExcelGraphicStoredAvailable = () => _setGraphicStoredAvailableExportExcel();
    const sumStandsCraftTypeCount = (eventsData?.exhibitionEvents?.data || []).reduce(
        (sum, event) => sum + (event?.standsCraftTypeCount || 0),
        0
    );


    return (
        <PageWrapDefault
            className="page-graphic-storage"
            dataExist={ true }
            title={ <Localize>PAGES.Title_Exhibitions</Localize> }
        >
            <Tables.Main
                model="exhibitionEvents"
                query={ GET_EVENTS }
                varSet={ { perPage: 100, whereCrafts: { column: 'TYPE', value: "collect_graphics" } } }
                routeUrl={ `${ basePath }` }
                currentPage={ match ? parseInt(match.params.pageNum) : 1 }
                searchText={ searchText }
                objFilter={ filters || gqlBuilderWhere(graphicStorageFilters) }
                tableHelper={ tableHelper }
                setVariables={ setTableVariables }
            >
                <div className="table-action-bar">

                    <div className="col">
                        <Events.Filters.Table
                            setSearchText={ setSearchText }
                            setFilters={ setFilters }
                            filters={ filters }
                            eventsFilters={ graphicStorageFilters }
                            filterTableName={ filterTableName } />
                        <TotalItems
                            pageInfo={ tableVariables ? { total: sumStandsCraftTypeCount } : null }
                        />
                    </div>

                    <div className="col">
                        <Button
                            type='outline'
                            style={ { maxWidth: '100%' } }
                            onClick={ handleExportExcelGraphicStoredAll }
                            loading={ loadingMutationGraphicStoredAllExportExcel }
                        >
                            <Icons.Download />&nbsp;&nbsp;<Localize>GLOBAL.Button_Text_AvailableStoredGraphics</Localize>
                        </Button>
                        <Button
                            type='outline'
                            style={ { maxWidth: '100%' } }
                            onClick={ handleExportExcelGraphicStoredAvailable }
                            loading={ loadingMutationGraphicStoredAvailableExportExcel }
                        >
                            <Icons.Download />&nbsp;&nbsp;<Localize>GLOBAL.Button_Text_EverStoredGraphics</Localize>
                        </Button>
                    </div>
                </div>

            </Tables.Main>
        </PageWrapDefault>
    )
};

export default GraphicStoragePage;
